import { createUseStyles } from 'react-jss'
import React, { useEffect, useState } from 'react'
import Slider from 'react-slick'

const useStyles = createUseStyles({
    slickSlide: {
        float: 'left'
    },
    slickTrackFix: {
        '& .slick-track': {
            // transform: 'translateZ(0) !important'
        }
    }
})

function ProductSlider({ images }) {
    const classes = useStyles()
    const [nav1, setNav1] = useState(null)
    const [nav2, setNav2] = useState(null)
    const [slider1, setSlider1] = useState(null)
    const [slider2, setSlider2] = useState(null)

    useEffect(() => {
        setNav1(slider1)
        setNav2(slider2)
    })

    const settingsMain = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        rtl: false,
        asNavFor: '.slider-nav'
    }

    const settingsThumbs = {
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        centerMode: true,
        swipeToSlide: true,
        focusOnSelect: true,
        centerPadding: '10px',
        arrows: false,
        vertical: true,
        infinite: images.length > 4,
        rtl: true
    }

    return (
        <div className="slider-wrapper ProductSlider flex flex-row-reverse">
            <Slider {...settingsMain} asNavFor={nav2} className="w-4/5 float-left" ref={(slider) => setSlider1(slider)}>
                {images?.map((meta, idx) => (
                    <div className="slick-slide p-2" key={idx}>
                        <img className="slick-slide-image rounded-xl" itemProp="image" src={`/api/${meta?.value}`} />
                        {/* <label className="slick-slide-label">
                            {slide.label}
                        </label> */}
                    </div>
                ))}
            </Slider>
            <div className={`thumbnail-slider-wrap2 w-1/5 float-right ${classes.slickTrackFix}`}>
                <Slider {...settingsThumbs} asNavFor={nav1} ref={(slider) => setSlider2(slider)}>
                    {images?.map((meta, idx) => (
                        <div className="slick-slide p-2" key={idx}>
                            <img className="slick-slide-image rounded-xl" itemProp="image" src={`/api/${meta?.value}`} />
                        </div>
                    ))}
                </Slider>
            </div>
        </div>
    )
}

export { ProductSlider }
